import { Sensor, SensorChannel } from '../types';

export type SplitSensorRow = Sensor & {
  _isSplitChannel: true;
  _channel: 1 | 2;
  _channelConfig: SensorChannel | null;
  name: string;
};

export type SensorRow = Sensor | SplitSensorRow;

export function isSplitRow(s: SensorRow): s is SplitSensorRow {
  return '_isSplitChannel' in s;
}

export function expandSensors(sensors: Sensor[]): SensorRow[] {
  return sensors.flatMap(s => {
    if (s.type !== '5' && s.type !== '6') return [s];
    // Auto-split all dual-channel sensors; use configured display_name if available
    const ch1Config = s.channels?.find(c => c.channel === 1) ?? null;
    const ch2Config = s.channels?.find(c => c.channel === 2) ?? null;
    return ([1, 2] as const).map(ch => ({
      ...s,
      name: (ch === 1 ? ch1Config?.display_name : ch2Config?.display_name) || `${s.name} (Ch ${ch})`,
      _isSplitChannel: true as const,
      _channel: ch,
      _channelConfig: ch === 1 ? ch1Config : ch2Config,
    }));
  });
}
